module.exports = __webpack_public_path__ + "static/media/player_50p.6acd4fba.png";